import { useQuery } from '@tanstack/react-query';
import { AutoRefreshAvailabilityDto } from '@/Config/api/queryClient';
import { QueryKey } from '@/Config/api/queryKey';

/** Whether the account's plan unlocks per-article URL auto-refresh (paid only). */
export const useAutoRefreshAvailability = () => {
  const query = useQuery<AutoRefreshAvailabilityDto>({
    queryKey: [QueryKey.knowledgeBase.autoRefresh],
  });

  return {
    available: query.data?.available ?? false,
    isLoading: query.isLoading,
  };
};
